import { render, staticRenderFns } from "./App.vue?vue&type=template&id=00ead16e&scoped=true&lang=pug&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "@templates/App/App.styl?vue&type=style&index=0&id=00ead16e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ead16e",
  null
  
)

export default component.exports